import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/apps/web/app/[deviceTheme]/[region]/[locale]/blog/[slug]/error.tsx");
